import styled from "styled-components";

const SummaryLine = ({ title, data }) => {
  return (
    <Wrap>{title}: <strong>{data}</strong></Wrap>
  )
}

export default SummaryLine


const Wrap = styled.p`
text-align: center;
margin: 0;
color: var(--heading-color-2);
font-size: 14px;

& strong {
  font-weight: 500;
  color: var(--heading-color-1);
}
`